import BackendService from './BackendService';

async function getChainShops() {
  return BackendService.getData('/shop_chains/');
}
async function getStockTransfer(id) {
  return BackendService.getData(`/items/stock/transfer/${id}/`);
}
async function getStockTransferHistory(params = {}) {
  return BackendService.getData('/items/stock/transfer/', {}, params);
}
async function createStockTransfer(data = {}) {
  return BackendService.postData('/items/stock/transfer/', data);
}
async function updateStockTransfer(id, data = {}) {
  return BackendService.patch(`/items/stock/transfer/${id}/`, data);
}
async function receiveStockTransfer(id, data = {}) {
  return BackendService.patch(`/items/stock/transfer/${id}/receive/`, data);
}
async function rejectStockTransfer(id) {
  return BackendService.patch(`/items/stock/transfer/${id}/reject/`);
}

async function getInternalStockTransfer(id) {
  return BackendService.getData(`/warehouse/transfers/${id}/`);
}
async function getInternalStockTransferHistory(params = {}) {
  return BackendService.getData('/warehouse/transfers/', {}, params);
}
async function createInternalStockTransfer(data = {}) {
  return BackendService.postData('/warehouse/transfers/', data);
}
async function updateInternalStockTransfer(id, data = {}) {
  return BackendService.patch(`/warehouse/transfers/${id}/`, data);
}
async function deleteInternalStockTransfer(id) {
  return BackendService.destroy(`/warehouse/transfers/${id}/`);
}

const StockTransferService = {
  getChainShops,
  getStockTransfer,
  getStockTransferHistory,
  createStockTransfer,
  updateStockTransfer,
  receiveStockTransfer,
  rejectStockTransfer,
  getInternalStockTransfer,
  getInternalStockTransferHistory,
  createInternalStockTransfer,
  updateInternalStockTransfer,
  deleteInternalStockTransfer,
};

export default StockTransferService;
